import { fadeIn } from './fade.js';

export function xAxisLabelFormatter(dates) {
  return function(value, index) {
    const firstIndex = dates.indexOf(value);

    // Only show first occurrence of each value
    if (index !== firstIndex) return '';

    const lastIndex = dates.length - 1;
    const secondToLastIndex = dates.length - 2;

    // Check if first and second would both render - hide first
    if (index === 0) {
      const secondFirstIndex = dates.indexOf(dates[1]);
      if (secondFirstIndex === 1) return '';
    }

    // Check if last and second-to-last would both render - hide last
    if (index === lastIndex) {
      const secondToLastFirstIndex = dates.indexOf(dates[secondToLastIndex]);
      if (secondToLastFirstIndex === secondToLastIndex) return '';
    }

    return value;
  };
}

export function buildOptions(dates, values) {
  const min = Math.min(...values);
  const max = Math.max(...values);
  const range = max - min;
  const topPadding = range * 0.1 || 0.1;
  const bottomPadding = Math.max(range * 0.35, 0.10);
  const opacities = fadeIn(values.length);

  return {
    grid: {
      left: '1%', top: 0, right: '1%', bottom: 0,
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: dates,
      axisLine: { lineStyle: { color: '#888' } },
      axisLabel: {
        interval: 0,
        formatter: xAxisLabelFormatter(dates)
      }
    },
    yAxis: {
      type: 'value',
      min: Math.floor((min - bottomPadding) * 100) / 100,
      max: Math.ceil((max + topPadding) * 100) / 100,
      axisLabel: {
        show: true,
        formatter: '{value}%',
      },
      splitLine: { show: true }
    },
    series: [{
      name: 'Last 90 Days',
      type: 'bar',
      barMinHeight: 90,
      data: values.map((value, index) => ({ value, itemStyle: { opacity: opacities[index] } })),
      barMaxWidth: '50%',
      itemStyle: {
        borderRadius: [8, 8, 0, 0],
      },
      label: {
        show: false
      }
    }]
  };
}
